import { useBrand } from '../brand/BrandProvider';

/** The product's name, hard-coded on purpose (steward-app#2488): the AI, the Steward team and
 *  references to the software itself name Steward on every host, never a brand field. */
export const STEWARD = 'Steward';

/**
 * The "with Steward" endorser line (steward-app#2488, Matt 2026-10-19): a small muted line under
 * the bronze rule of a firm-branded lockup. Renders nothing on the default Steward brand, where
 * the wordmark already says it. Callers pass the colour and spacing, since the sidebar and the
 * navy sign-in panel sit on different grounds.
 */
export function WithSteward({ className = '' }: { className?: string }) {
  const { isWhiteLabel } = useBrand();
  if (!isWhiteLabel) return null;
  return (
    <div data-testid="with-steward" className={`font-sans ${className}`}>
      with {STEWARD}
    </div>
  );
}
